exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Abel);", ""]);

// module
exports.push([module.id, "html{background:#000}body,html{height:100%}body{font-family:Abel,sans-serif;font-size:10px;margin:0;padding:0}.base,.video-box{height:100%;width:100%}", "", {"version":3,"sources":["/build/src/code.justin.tv/web/wall/src/components/app/style.css"],"names":[],"mappings":"AAEA,KAEE,eAAiB,CAClB,AAED,UAJE,WAAa,CAUd,AAND,KACE,4BAA8B,AAC9B,eAAgB,AAChB,SAAU,AACV,SAAW,CAEZ,AAQD,iBALE,YAAa,AACb,UAAY,CAOb","file":"style.css","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Abel');\n\nhtml {\n  height: 100%;\n  background: #000;\n}\n\nbody {\n  font-family: Abel, sans-serif;\n  font-size: 10px;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n.base {\n  height: 100%;\n  width: 100%;\n}\n\n\n.video-box {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./src/components/app/style.css
// module id = 49
// module chunks = 0